module.exports = __webpack_public_path__ + "img/icon-user.5bfb24cf.svg";